import { format } from "date-fns";
import * as XLSX from "xlsx";

export const useExportToExcel = (
  stockMarkets: any[],
  selectedMarket: number | string,
) => {
  const exportToExcel = (data: any[]) => {
    if (!data || !data.length) {
      alert("No data to export");
      return;
    }

    const marketName =
      stockMarkets?.find((market: any) => market.id == selectedMarket)
        ?.market_name || "stocks";

    const exportData = data.map((stock: any) => ({
      ID: stock.id,
      Sector: stock.sector_name,
      "Company Name": stock.company_name,
      "Ticker Symbol": stock.ticker_symbol,
      "Financial Source": stock.falcon_fiscal_year
        ? `Falcon FY ${stock.falcon_fiscal_year}${stock.falcon_latest_quarter_date ? ` (${stock.falcon_latest_quarter_date})` : ""}`
        : "Manual / Existing",
      "Latest Quarter": stock.latest_revenue_year
        ? `${stock.latest_revenue_year} Q${stock.latest_revenue_quarter} (${stock.latest_revenue_date})`
        : "-",
      Open: stock.open,
      High: stock.high,
      Low: stock.low,
      "Last Traded Price": stock.closed,
      "Last Traded Date": stock.last_traded_date,
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    ws["!cols"] = [
      { wch: 8 },
      { wch: 20 },
      { wch: 25 },
      { wch: 15 },
      { wch: 24 },
      { wch: 22 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 18 },
      { wch: 18 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Stocks");
    XLSX.writeFile(
      wb,
      `${marketName} Stocks Export_${format(new Date(), "yyyy-MM-dd")}.xlsx`,
    );
  };

  return { exportToExcel };
};
